(()=>{
  const init=()=>document.querySelectorAll('[data-morgan-account]').forEach(root=>{
    if(root.dataset.accountReady)return;
    root.dataset.accountReady='true';
    const feedback=!!root.querySelector('[data-account-recovery-feedback]');
    const update=focus=>{
      const recover=location.hash==='#recover'||(feedback&&location.hash!=='#login');
      root.dataset.accountView=recover?'recover':'login';
      if(focus)root.querySelector(recover?'#recover h1':'#login h1')?.focus({preventScroll:true});
    };
    update(false);
    window.addEventListener('hashchange',()=>update(true));
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
